export enum TemplatePlaceholder {
  ContactName = "$contact_name$",
  AgentName = "$agent_name$",
}
